import Icon from '../components/Icon';

const NationalParkFilled = Icon(
  'national-park-filled',
  <>
    <path
      fillRule="evenodd"
      d="M17.833 5.438h2.847c.79 0 1.406.688 1.31 1.472C21.596 10.117 19.84 17.512 12 22 4.161 17.512 2.404 10.118 2.01 6.91a1.316 1.316 0 0 1 1.31-1.473h2.847l-.674-1.604A1.32 1.32 0 0 1 6.71 2H17.29c.943 0 1.581.963 1.215 1.833zm-5.827-.188h.007H12zm0 0c.275.002.476.106.697.626.493 1.182 1.604 2.002 2.649 2.771.415.29.504.886.238 1.236-.449.594-1.69.102-2.547-.766.191 1.584 1.606 2.785 2.739 3.519h.002c.965.589.115 2.08-.886 1.548a14 14 0 0 1-1.24-.766c-.298-.208-.706.014-.706.377v3.292c0 .09-.074.163-.163.163H11.22a.163.163 0 0 1-.163-.163v-3.292c0-.363-.409-.585-.707-.377-.407.286-.828.54-1.24.766-1 .531-1.85-.958-.885-1.548 1.132-.732 2.545-1.932 2.738-3.513-.855.864-2.094 1.338-2.55.736-.306-.405-.166-.922.248-1.212 1.044-.768 2.154-1.588 2.648-2.771.22-.52.423-.624.697-.626"
      clipRule="evenodd"
    />
  </>
);

export default NationalParkFilled;
